import { render, staticRenderFns } from "./CoursePlayOffice.vue?vue&type=template&id=b041559e&scoped=true&style=height%3Aauto%3B&"
import script from "./CoursePlayOffice.vue?vue&type=script&lang=js&"
export * from "./CoursePlayOffice.vue?vue&type=script&lang=js&"
import style0 from "./CoursePlayOffice.vue?vue&type=style&index=0&id=b041559e&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b041559e",
  null
  
)

export default component.exports